/* import __COLOCATED_TEMPLATE__ from './go-live.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type RouterService from '@ember/routing/router-service';
import type SalesforceConfiguration from 'embercom/models/standalone/salesforce-configuration';
import type { Step } from 'embercom/components/standalone/common/stepper-item';
import type IntlService from 'embercom/services/intl';
interface Signature {
  Args: {};
}
export default class GoLiveComponent extends Component<Signature> {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare router: RouterService;
  @service declare intl: IntlService;

  get steps(): Array<Step> {
    return [
      {
        id: 'set-fin-identity',
        title: this.intl.t('standalone.deploy.salesforce.cases.go-live.steps.set-fin-identity'),
        button: {
          icon: 'person',
          text: this.intl.t(
            'standalone.deploy.salesforce.cases.go-live.steps.set-fin-identity-button',
          ),
          disabled: false,
          href: this.router.urlFor('apps.app.standalone.deploy.salesforce.cases.connect', {
            queryParams: {
              section: 'fin-identity',
            },
          }),
          isExternal: false,
        },
      },
      {
        id: 'select-email-origins',
        title: this.intl.t('standalone.deploy.salesforce.cases.go-live.steps.select-email-origins'),
        button: {
          icon: 'account',
          text: this.intl.t(
            'standalone.deploy.salesforce.cases.go-live.steps.select-email-origins-button',
          ),
          disabled: false,
          href: this.router.urlFor('apps.app.standalone.deploy.salesforce.cases.configure-emails', {
            queryParams: {
              section: 'select-email-origins',
            },
          }),
          isExternal: false,
        },
      },
      {
        id: 'select-agent-email',
        title: this.intl.t('standalone.deploy.salesforce.cases.go-live.steps.select-agent-email'),
        button: {
          icon: 'message',
          text: this.intl.t(
            'standalone.deploy.salesforce.cases.go-live.steps.select-agent-email-button',
          ),
          disabled: false,
          href: this.router.urlFor('apps.app.standalone.deploy.salesforce.cases.configure-emails', {
            queryParams: {
              section: 'select-fins-email',
            },
          }),
          isExternal: false,
        },
      },
      {
        id: 'training',
        title: this.intl.t('standalone.deploy.salesforce.cases.go-live.steps.training'),
        button: {
          icon: 'article',
          text: this.intl.t('standalone.deploy.salesforce.cases.go-live.steps.training-button'),
          href: this.router.urlFor('apps.app.knowledge-hub.overview'),
        },
      },
      {
        id: 'workflow',
        title: this.intl.t('standalone.deploy.salesforce.cases.go-live.steps.workflow'),
        button: this.salesforceConfig?.workflowRulesetId
          ? {
              icon: 'workflows',
              text: this.intl.t('standalone.deploy.salesforce.cases.go-live.steps.workflow-button'),
              href: this.router.urlFor(
                'apps.app.standalone.deploy.salesforce.cases.workflow.show',
                this.salesforceConfig.workflowRulesetId,
                {
                  queryParams: {
                    returnPath: this.router.currentRouteName,
                  },
                },
              ),
            }
          : undefined,
      },
    ];
  }

  get salesforceConfig(): SalesforceConfiguration {
    return this.finStandaloneService.salesforceConfig!;
  }

  get isNotConfigured() {
    return this.salesforceConfig?.isPendingSetup || false;
  }

  @action
  async activate() {
    await this.salesforceConfig.activateForCases();
    return true;
  }

  @action
  async deactivate() {
    await this.salesforceConfig.deactivateForCases();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Salesforce::Cases::GoLive': typeof GoLiveComponent;
  }
}
